// src/components/bodyBlocks/presentation/PresentationBlock.tsx
import { useEffect } from "react";
import HeroBlock from "./pages/HeroBlock";
import StoryBlock from "./pages/StoryBlock";
import PurposeValuesBlock from "./pages/PurposeValuesBlock";

export default function PresentationBlock() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" as ScrollBehavior });
  }, []);

  return (
    <main className="w-full">
      <HeroBlock />
      <StoryBlock />
      <PurposeValuesBlock />
    </main>
  );
}
